import { DataGridErrorState } from '../../common/DataGrid/DataGridErrorState';

export function AppsTableErrorState() {
  return (
    <DataGridErrorState colSpan={5}>
      There was an error loading the applications. Please, try again later.
    </DataGridErrorState>
  );
}
